/* Palmiye Gurme — ürün kartı varyant çipleri
 * Markup: snippets/bup-product-card.liquid ([data-pg-card-variants])
 * Fiyatlar sunucuda biçimlenir (data-price / data-old / data-pct); burada yalnızca yerleştirilir.
 * Tek dinleyici (event delegation): sonsuz kaydırma / "daha fazla yükle" ile gelen kartlar da çalışır.
 */
(() => {
  'use strict';

  function select(chip) {
    if (chip.hasAttribute('data-soldout')) return;
    const group = chip.closest('[data-pg-card-variants]');
    const card = chip.closest('.pg-bup-product-card');
    if (!group || !card) return;

    group.querySelectorAll('[data-pg-card-variant]').forEach((c) => c.setAttribute('aria-checked', c === chip ? 'true' : 'false'));

    const cur = card.querySelector('[data-pg-card-current]');
    if (cur) cur.textContent = chip.dataset.price || '';

    const oldWrap = card.querySelector('[data-pg-card-old]');
    const oldVal = card.querySelector('[data-pg-card-old-value]');
    const hasOld = !!chip.dataset.old;
    // Satır her zaman yer kaplar (kart hizası sabit); indirim yoksa yalnızca görünmez olur
    if (oldWrap) { oldWrap.hidden = false; oldWrap.classList.toggle('is-empty', !hasOld); oldWrap.toggleAttribute('aria-hidden', !hasOld); }
    if (oldVal && hasOld) oldVal.textContent = chip.dataset.old;

    const badge = card.querySelector('[data-pg-card-badge]');
    const pct = card.querySelector('[data-pg-card-pct]');
    const p = parseInt(chip.dataset.pct || '0', 10);
    if (badge) badge.hidden = !(p > 0);
    if (pct) pct.textContent = String(p);

    const form = document.getElementById(group.dataset.form);
    const idInput = form && form.querySelector('[data-pg-card-id]');
    if (idInput) idInput.value = chip.dataset.pgCardVariant;

    group.classList.remove('is-invalid');
    const hint = card.querySelector('[data-pg-card-hint]');
    if (hint) hint.hidden = true;
    // Seçilen çip kaydırılabilir şeritte görünür alana gelsin
    if (chip.scrollIntoView && group.scrollWidth > group.clientWidth) chip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  /* Varyant seçilmeden "Sepete Ekle": isteği durdur, çiplerin altında uyarı göster.
     Tema ProductForm'u form 'submit' olayını dinler; belge yakalama aşamasında ondan önce çalışırız. */
  function warn(form) {
    const card = form.closest('.pg-bup-product-card');
    const group = card && card.querySelector('[data-pg-card-variants]');
    const hint = card && card.querySelector('[data-pg-card-hint]');
    if (!group) return;
    if (hint) hint.hidden = false;
    group.classList.remove('is-invalid');
    void group.offsetWidth; // animasyonu yeniden başlat
    group.classList.add('is-invalid');
    const first = group.querySelector('[data-pg-card-variant]:not([data-soldout])');
    if (first) first.focus({ preventScroll: true });
  }
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const idInput = form && form.querySelector && form.querySelector('[data-pg-card-id]');
    if (!idInput || idInput.value) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    warn(form);
  }, true);

  /* ---- Çip şeridi: kaydırma okları + fareyle sürükleme ----
     Performans (Tur 17): ölçümler (scrollWidth/clientWidth/scrollLeft) önce TOPLU okunur, ardından
     tek seferde yazılır — kart başına okuma→yazma döngüsü her kartta zorunlu layout tetikliyordu.
     Şeritler yalnızca görünür alana yaklaşınca ölçülür (IntersectionObserver); boyut değişimi ResizeObserver ile. */
  const parts = (wrap) => {
    if (!wrap._pg) {
      wrap._pg = {
        track: wrap.querySelector('[data-pg-card-variants]'),
        prev: wrap.querySelector('[data-pg-chips-nav="-1"]'),
        next: wrap.querySelector('[data-pg-chips-nav="1"]'),
      };
    }
    return wrap._pg;
  };
  const measure = (wrap) => {
    const { track } = parts(wrap);
    if (!track) return null;
    return { wrap, max: track.scrollWidth - track.clientWidth, left: track.scrollLeft };
  };
  const apply = (m) => {
    if (!m) return;
    const { prev, next } = parts(m.wrap);
    const over = m.max > 2;
    if (prev) prev.hidden = !(over && m.left > 2);
    if (next) next.hidden = !(over && m.left < m.max - 2);
    m.wrap.classList.toggle('is-overflow', over);
  };

  const pending = new Set();
  let raf = 0;
  const flush = () => {
    raf = 0;
    const list = Array.from(pending);
    pending.clear();
    const ms = list.map(measure);   // 1) tüm okumalar
    ms.forEach(apply);              // 2) tüm yazmalar
  };
  const queue = (wrap) => { pending.add(wrap); if (!raf) raf = requestAnimationFrame(flush); };

  const ro = 'ResizeObserver' in window
    ? new ResizeObserver((entries) => entries.forEach((en) => { const w = en.target.closest('[data-pg-chips-wrap]'); if (w) queue(w); }))
    : null;
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        const { track } = parts(en.target);
        if (track && ro) ro.observe(track);
        queue(en.target);
      }), { rootMargin: '300px 0px' })
    : null;

  function initChips(root) {
    (root || document).querySelectorAll('[data-pg-chips-wrap]:not([data-pg-ready])').forEach((wrap) => {
      wrap.setAttribute('data-pg-ready', '');
      const { track } = parts(wrap);
      if (!track) return;
      track.addEventListener('scroll', () => queue(wrap), { passive: true });
      if (io) io.observe(wrap); else queue(wrap);
    });
  }
  const runInit = () => initChips(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInit); else runInit();
  // Sonsuz kaydırma / daha fazla yükle ile gelen kartlar: yalnızca çip şeridi içeren düğüm eklenince tara
  let mo = 0;
  const hasChips = (n) => n.nodeType === 1 && (n.matches('[data-pg-chips-wrap]') || n.querySelector('[data-pg-chips-wrap]'));
  new MutationObserver((records) => {
    if (mo) return;
    for (const r of records) {
      for (const n of r.addedNodes) {
        if (hasChips(n)) { mo = requestAnimationFrame(() => { mo = 0; runInit(); }); return; }
      }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  if (!ro) {
    let rT = null;
    window.addEventListener('resize', () => { clearTimeout(rT); rT = setTimeout(() => document.querySelectorAll('[data-pg-chips-wrap][data-pg-ready]').forEach(queue), 150); }, { passive: true });
  }

  // Fareyle sürükleyerek kaydırma (dokunmatikte tarayıcının kendi kaydırması kullanılır)
  let drag = null;
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    const track = e.target.closest && e.target.closest('[data-pg-card-variants]');
    if (!track || track.scrollWidth <= track.clientWidth) return;
    drag = { track, x: e.clientX, left: track.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x;
    if (Math.abs(dx) > 5) drag.moved = true;
    if (drag.moved) drag.track.scrollLeft = drag.left - dx;
  });
  document.addEventListener('pointerup', () => {
    if (drag && drag.moved) {
      const t = drag.track;
      // sürükleme bitiminde gelen tıklama çip seçmesin
      const stop = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
      t.addEventListener('click', stop, { capture: true, once: true });
      setTimeout(() => t.removeEventListener('click', stop, { capture: true }), 60);
    }
    drag = null;
  });

  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-pg-chips-nav]');
    if (nav) {
      const track = nav.parentElement.querySelector('[data-pg-card-variants]');
      if (track) track.scrollBy({ left: Number(nav.dataset.pgChipsNav) * Math.max(80, track.clientWidth * 0.7), behavior: 'smooth' });
      return;
    }
    const chip = e.target.closest('[data-pg-card-variant]');
    if (chip) select(chip);
  });

  // Klavye: radyo grubu gibi ok tuşlarıyla gezinme
  document.addEventListener('keydown', (e) => {
    const chip = e.target.closest('[data-pg-card-variant]');
    if (!chip || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
    const chips = Array.from(chip.parentElement.querySelectorAll('[data-pg-card-variant]:not([data-soldout])'));
    const i = chips.indexOf(chip);
    if (i < 0) return;
    e.preventDefault();
    const next = chips[(i + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1) + chips.length) % chips.length];
    next.focus();
    select(next);
  });
})();
